<template>
  <Field class="form-field" :width="width">
    <label v-if="label" class="form-label" :for="id">
      {{ label }}
    </label>
    <div class="flex items-center space-x-2">
      <template v-for="(chunk, n) in chunks" :key="n">
        <div v-if="separator && n">
          <span class="text-gray-500 -mx-1">{{ separator }}</span>
        </div>
        <Input
          v-model="value[n]"
          class="text-center"
          :placeholder="placeholder(n)"
          :autofocus="autofocus && !n"
          :class="{ error }"
          :size="length"
          :ref="el => input[n] = el"
          @input="onInput($event, n)"
        />
      </template>
    </div>
    <div v-if="error" class="form-error">
      {{ error }}
    </div>
  </Field>
</template>

<script>
import Field from 'Web/Form/Fields/Field.vue';
import Input from 'Web/Form/Inputs/Input.vue';
import uid from '@/helpers/uid';
import { onBeforeUpdate, ref, watch } from 'vue';

export default {
  inheritAttrs: false,
  emits: [
    'update:modelValue',
  ],
  components: {
    Field,
    Input,
  },
  props: {
    error: String,
    autofocus: Boolean,
    id: {
      type: String,
      default: uid,
    },
    label: String,
    width: String,
    chunks: {
      type: [String, Number],
      default: 4,
    },
    length: {
      type: [String, Number],
      default: 2,
    },
    separator: {
      type: String,
      default: '–',
    },
    placeholder: {
      type: String,
      default: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      required: true,
    },
  },
  setup(props, { emit }) {
    const input = ref([]);
    const value = ref([]);

    onBeforeUpdate(() => {
      input.value = [];
    });

    function select(index) {
      input.value[index]?.focus();
      input.value[index]?.select();
    }

    function placeholder(n) {
      const count = props.placeholder.length;
      const char = props.placeholder[n % count];

      return char.repeat(props.length);
    }

    function onInput(event, n) {
      const chunks = event.target.value
        .replace(/[^0-9a-z]/gi, '')
        .match(new RegExp(`.{1,${props.length}}`, 'g')) ?? [];

      if (!chunks.length) {
        value.value[n] = chunks[0];
        return select(n - 1);
      }

      chunks.slice(0, props.chunks - n).forEach((chunk, index) => {
        value.value[n + index] = chunk;

        if (chunk.length == props.length)
          select(n + index + 1);
      });
    }

    watch(() => value.value, value => {
      emit('update:modelValue', value.join(''));
    }, { deep: true });

    return {
      input,
      onInput,
      placeholder,
      value,
    }
  }
}
</script>
